import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Clock, CheckCircle } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
import { cn } from '../../lib/utils';

export default function ServiceCard({ service }) {
  return (
    <Link 
      to={`/services/${service.id}`}
      className="deal-card block rounded-2xl group overflow-hidden"
      data-testid={`service-card-${service.id}`}
    >
      {/* Image */}
      <div className="relative aspect-video overflow-hidden bg-zinc-100">
        {service.image_url ? (
          <img 
            src={service.image_url} 
            alt={service.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-violet-500/20 to-purple-500/20">
            <span className="font-display text-4xl text-violet-400">{service.category[0]}</span>
          </div>
        )}
        
        {/* Availability Badge */}
        <div className={cn(
          "absolute top-3 right-3 px-3 py-1 rounded-full flex items-center gap-1.5",
          service.is_available 
            ? "bg-green-500 text-white" 
            : "bg-zinc-200 text-zinc-600"
        )}>
          {service.is_available && <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />}
          <span className="text-xs font-semibold">
            {service.is_available ? 'Available Now' : 'Busy'}
          </span>
        </div>
        
        {/* Category */}
        <div className="absolute bottom-3 left-3 bg-violet-500 text-white px-3 py-1 rounded-full">
          <span className="text-xs font-semibold">{service.category}</span>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-4">
        <p className="text-xs text-zinc-500 mb-1">{service.vendor_name}</p>
        <h3 className="font-semibold text-zinc-900 mb-2 group-hover:text-violet-600 transition-colors">
          {service.name}
        </h3>
        
        <p className="text-sm text-zinc-500 line-clamp-2 mb-3">
          {service.description}
        </p>
        
        {/* Details */}
        <div className="flex items-center gap-4 text-xs text-zinc-500 mb-3">
          <div className="flex items-center gap-1">
            <Clock size={12} />
            <span>{service.duration_minutes} min</span>
          </div>
          {service.reviews_count > 0 && (
            <div className="flex items-center gap-1">
              <Star size={12} className="text-yellow-500 fill-yellow-500" />
              <span>{service.rating.toFixed(1)}</span>
            </div>
          )}
        </div>
        
        {/* Price */}
        <div className="flex items-center justify-between">
          <span className="font-display font-bold text-xl text-violet-600">
            {formatCurrency(service.price)}
          </span>
          <span className="text-sm font-semibold text-violet-600">Book Now →</span>
        </div>
      </div>
    </Link>
  );
}
